import VueMask, { VueMaskDirective, VueMaskFilter } from 'v-mask'
import Vue from 'vue'

Vue.use(VueMask)
Vue.directive('mask', VueMaskDirective)
Vue.filter('VMask', VueMaskFilter)
